import { useCopyToClipboard } from '@hooks/useCopyToClipboard';
import LinkIcon from '@mui/icons-material/Link';
import { Button } from '@mui/material';

/** Copies the customer Intake Status link so staff can send it to the practice. */
export function IntakeStatusCopyLinkButton({ url }: { url: string }) {
  const copy = useCopyToClipboard();
  return (
    <Button
      size="small"
      variant="text"
      startIcon={<LinkIcon />}
      onClick={() => copy(url, 'Intake status link')}
    >
      Copy link
    </Button>
  );
}
